<template lang="pug">
    v-dialog(v-model="dialog" max-width="640" scrollable persistent :fullscreen="$vuetify.breakpoint.smAndDown")
        v-card(tile)
            v-overlay(:value="saving" absolute)
                v-progress-circular(indeterminate size="64")
            v-card-title.title.caption--text {{title}}
            v-container(tag="v-card-text" gris-list-xl)
                v-form(id="form" ref="refForm" @submit="onSubmit")
                    v-layout(wrap)
                        v-flex(xs12)
                            v-autocomplete(v-model="companyId" ref="refCompany" item-value="id" item-text="code"
                                :items="companies" :loading="companyLoading" :filter="onFilterCompany" :search-input.sync="filterCompany"
                                :rules="[rules.required]"
                                :label="$t('pages.settings.calendar.labels.company.title')")
                                template(#item="data")
                                    v-list-item-content
                                        v-list-item-title {{data.item.code}}
                                        v-list-item-subtitle {{data.item.name}}
                        v-flex(xs12)
                            v-select(v-model="serviceType" :rules="[rules.required]"
                                :items="calendarServiceTypes" :loading="serviceTypesFetching"
                                label="Service Type")

                        v-flex(xs12)
                            v-alert(
                                class="py-2"
                                :color="folderName ? 'header' : 'error'"
                                border="left"
                                elevation="1"
                                colored-border
                                icon="mdi-folder"
                            )
                                v-layout(column)
                                    .caption {{$t('pages.settings.calendar.labels.folderTitle.title')}}
                                    .subheading(v-if="folderName") {{folderName}}
                                    .subheading(v-else) {{$t('pages.settings.calendar.labels.folderTitle.invalid')}}

                        v-flex(xs12)
                            v-select(v-model="calendarType" :rules="[rules.required]"
                                :items="calendarCalendarTypes"
                                label="Calendar Type")

                        v-flex(xs12)
                            v-radio-group(v-model="status" :mandatory="false" row)
                                v-radio(:label="$t(`pages.settings.user.table.headers.status.values.false`)" color="red" :value="false")
                                v-radio(:label="$t(`pages.settings.user.table.headers.status.values.true`)" color="green" :value="true")
                                template(#prepend)
                                    .body-1 {{$t('pages.settings.user.table.headers.status.title')}}


                        user-permission-finder(ref="refFinder"
                            :users-selected.sync="users")

            v-card-actions
                v-checkbox(v-model="notify" :label="$t('pages.settings.calendar.labels.notification.title')" v-if="false").pl-2
                v-spacer
                v-btn(@click="close" color="grey" depressed).px-3.white--text
                    v-icon(left dark) mdi-cancel
                    | {{$t('general.cancel')}}

                v-btn(type="submit" form="form" color="primary" depressed).px-3
                    v-icon(left dark) mdi-content-save
                    | {{$t('general.save')}}
</template>

<script>
import rules from "../../mixins/rules";
import general from "../../mixins/general";
import crud from "../../mixins/crud";
import SearchBox from "../commons/SearchBox";
import cloneDeep from "lodash/cloneDeep";
import UserPermissionFinder from "../commons/UserPermissionFinder";

export default {
  name: "EditDialog",
  components: { SearchBox, UserPermissionFinder },
  mixins: [rules, general, crud],
  data() {
    return {
      mode: "create",
      dialog: false,
      saving: false,
      currentId: null,
      calendarType: null,
      serviceType: null,
      status: true,
      users: [],
      notify: false,
      companyId: null,
      companies: [],
      companyLoading: false,
      filterCompany: null
    };
  },
  computed: {
    showing: {
      get() {
        return this.dialog;
      }
    },
    title: {
      get() {
        return this.$t(`pages.settings.calendar.dialog.title.${this.mode}`);
      }
    },
    folderName: {
      get() {
        const i = this.companies.findIndex(c => c.id === this.companyId);
        if (i > -1 && typeof this.serviceType === "string") {
          return (
            this.companies[i].code + " - " + this.serviceType.toUpperCase()
          );
        }
        return "";
      }
    },
    tableHeaders: {
      get() {
        return [
          {
            text: this.$t(
              "pages.settings.user.table.headers['company.code'].title"
            ),
            align: "left",
            sortable: true,
            value: "company.code",
            class: ["body-2"]
          },
          {
            text: this.$t("pages.settings.user.table.headers.name.title"),
            value: "name",
            sortable: true,
            class: ["body-2"]
          },
          {
            text: this.$t("pages.settings.user.table.headers.email.title"),
            value: "email",
            sortable: true,
            class: ["body-2"]
          },
          {
            text: this.$t("pages.settings.user.table.headers.actions.title"),
            value: "action",
            align: "center",
            class: ["body-2"],
            sortable: false
          }
        ];
      }
    }
  },
  methods: {
    onFilterCompany(item) {
      return (
        typeof this.filterCompany === "string" &&
        (item.code.toLowerCase().includes(this.filterCompany.toLowerCase()) ||
          item.name.toLowerCase().includes(this.filterCompany.toLowerCase()))
      );
    },
    clear() {
      this.currentId = null;
      this.calendarType = null;
      this.serviceType = null;
      this.status = true;
      this.users = [];
      this.notify = false;
      this.companyId = null;
      this.companies = [];
      this.companyLoading = false;
      this.filterCompany = null;
    },
    show(mode, data = null) {
      this.clear();
      if (mode === "create") this.fetchServiceTypes(undefined);
      this.companyLoading = true;
      this.mode = mode;
      this.dialog = true;
      this.$nextTick(() => {
        this.$refs["refForm"].resetValidation();
      });

      if (mode === "edit" && data) {
        this.$nextTick(() => {
          this.currentId = data.id;
          // this.serviceType = data.service_type;
          this.calendarType = data.calendar_type;
          this.notify = data.notify;
          this.status = data.status;
          this.users = cloneDeep(data.users);

          this.fetchServiceTypes(undefined).then(items => {
            if (Array.isArray(items)) {
              const availableTypes = items
                .filter(({ status }) => status)
                .map(({ name }) => name);
              // this.types = newTypes;
              // console.log(availableTypes);
              if (availableTypes.includes(data.service_type)) {
                this.serviceType = data.service_type;
              }
            }
          });
        });
      }

      this.axios
        .get(`companies?allThin`)
        .then(res => {
          this.companies = res.data.filter(c => c.status);
          let idx = -1;
          if (mode === "edit" && data) {
            idx = this.companies.findIndex(i => i.id === data.company.id);
          }
          this.$nextTick(() => {
            if (idx > -1) this.companyId = this.companies[idx].id;
            this.$refs["refCompany"].focus();
          });
        })
        .finally(() => (this.companyLoading = false));
    },
    close() {
      this.$refs["refFinder"].close();
      this.$refs["refFinder"].clear();
      this.dialog = false;
    },
    onSubmit(e) {
      e.preventDefault();
      if (this.$refs["refForm"].validate()) {
        this.$confirm(this.$t("messages.saveConfirmation")).then(value => {
          if (value) {
            this.saving = true;
            setTimeout(() => {
              const data = {
                company_id: this.companyId,
                title: this.folderName,
                service_type: this.serviceType,
                calendar_type: this.calendarType,
                status: this.status,
                notify: this.notify,
                user_ids: this.users.map(user => user.id)
              };

              this.axios({
                url:
                  this.mode === "create"
                    ? `calendars`
                    : `calendars/${encodeURIComponent(this.currentId)}`,
                method: this.mode === "create" ? `post` : `put`,
                data
              })
                .then(response => {
                  this.saving = false;
                  this.close();
                  this.$emit("saved", response.data.data);
                })
                .catch(error => {
                  this.saving = false;
                  if (this.mode === "create") this.saveErrorHandler(error);
                  else this.updateErrorHandler(error);
                });
            }, 500);
          }
        });
      }
    }
  }
};
</script>
